import {v4 as uuidv4} from "uuid";
import localForage from "localforage";

export default {
  async getList(itemType) {
    return (await localForage.getItem(itemType)) || [];
  },

  async getListLength(itemType) {
    const list = (await localForage.getItem(itemType)) || [];
    return list.length;
  },

  async getItem(type, id) {
    const list = (await localForage.getItem(type)) || [];
    return list.find((el) => el.id === id);
  },

  async getImages(holderId) {
    const files = (await localForage.getItem("files")) || [];
    return files.filter(
      (el) => el.holderId === holderId && el.fileType === "image"
    );
  },

  async getFiles(holderId, all = false) {
    const files = (await localForage.getItem("files")) || [];
    if (all) return files;
    return files.filter((el) => el.holderId === holderId);
  },

  async saveItem(itemType, item) {
    const list = (await localForage.getItem(itemType)) || [];
    const index = list.findIndex((el) => el.id === item.id);
    if (index >= 0) list[index] = JSON.parse(JSON.stringify(item));
    else list.push(item);

    await localForage.setItem(itemType, list);
  },

  async deleteFile(fileId) {
    let files = (await localForage.getItem("files")) || [];
    files = files.filter((el) => el.id !== fileId);

    await localForage.setItem("files", files);
  },

  async deleteItem(itemType, itemId) {
    // 1. Удалим объект
    let list = (await localForage.getItem(itemType)) || [];
    list = list.filter((el) => el.id !== itemId);

    await localForage.setItem(itemType, list);

    // 2. Удалим файлы
    let files = (await localForage.getItem("files")) || [];
    files = files.filter((el) => el.holderId !== itemId);

    await localForage.setItem("files", files);
  },

  async savePhoto(holderType, holderId, file, ctx) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const files = await this.getFiles("", true);
      files.push({
        id: uuidv4(),
        name: "Фото_" + Date.now(),
        holderType: holderType,
        holderId: holderId,
        fileType: "image",
        description: "Фото",
        createdAt: new Date().toLocaleString(),
        src: reader.result,
      });
      await localForage.setItem("files", files);
      ctx.images = await this.getImages(holderId);
    };
  },

  async saveVoiceRecord(holderType, holderId, voice) {
    const reader = new FileReader();
    const blob = new Blob(voice, { type: "audio/wav" });
    reader.readAsDataURL(blob);
    reader.onload = async () => {
      const files = (await localForage.getItem("files")) || [];
      files.push({
        id: uuidv4(),
        name: "Аудио_" + Date.now(),
        holderType: holderType,
        holderId: holderId,
        fileType: "audio",
        description: "Аудио",
        createdAt: new Date().toLocaleString(),
        src: reader.result,
      });
      await localForage.setItem("files", files);
    };
  },

  async getDefaultPowerGridComplexId() {
    // Если PowerGridComplex единственный, то вернем его
    const list = (await this.getList("powerGridComplex")) || [];
    if (list.length === 1) return list[0].id;
    else return null;
  },

  async getDefaultAirLineId() {
    // Если AirLine единственный, то вернем его
    const list = (await this.getList("airLine")) || [];
    if (list.length === 1) return list[0].id;
    else return null;
  },

  fileSizeFormat(value, precision = undefined) {
    if (!value || isNaN(value)) return value;
    const sufixes = ["B", "kB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(value) / Math.log(1024));
    return (
      (value / Math.pow(1024, i)).toFixed(precision || 0) + " " + sufixes[i]
    );
  },

  async getCoordsIterateNumber() {
    const coordsIterateNumber = await localForage.getItem(
      "coordsIterateNumber"
    );
    if (coordsIterateNumber) return coordsIterateNumber;
    return 10; // По умолчанию
  },

  async getMaxDataSize() {
    const maxDataSize = await localForage.getItem("maxDataSize");
    if (maxDataSize) return maxDataSize;
    return "50 MB"; // По умолчанию
  },

  async clearLocalStorage() {
    await localForage.clear();
  },

  // Определение координат
  async getCurrentPositionArray(coordsArray) {
    const coordsIterateNumber = await this.getCoordsIterateNumber();
    for (let i = 1; i <= coordsIterateNumber; i++) {
      this.getCoordsStep(coordsArray);
    }
  },

  haversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371000; // радиус Земли в метрах
    const toRad = (x) => (x * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    return 2 * R * Math.asin(Math.sqrt(a));
  },

  getAverageCoordinates(coordsArray) {
    if (coordsArray.length === 0) return null;

    // 1. Черновой центр
    const roughCenter = coordsArray.reduce(
      (acc, p) => ({ lat: acc.lat + p.lat, lon: acc.lon + p.lon }),
      { lat: 0, lon: 0 }
    );
    roughCenter.lat /= coordsArray.length;
    roughCenter.lon /= coordsArray.length;

    // 2. Расстояния до центра
    const distances = coordsArray.map((p) => ({
      point: p,
      dist: this.haversineDistance(
        p.lat,
        p.lon,
        roughCenter.lat,
        roughCenter.lon
      ),
    }));

    // 3. Медиана расстояний
    const sorted = distances.map((d) => d.dist).sort((a, b) => a - b);
    const median = sorted[Math.floor(sorted.length / 2)];

    // 4. Фильтрация аномалий
    const threshold = median * 2; // можно настроить
    const filtered = distances
      .filter((d) => d.dist <= threshold)
      .map((d) => d.point);

    // 5. Средние координаты
    const avg = filtered.reduce(
      (acc, p) => ({ lat: acc.lat + p.lat, lon: acc.lon + p.lon }),
      { lat: 0, lon: 0 }
    );

    return {
      lat: avg.lat / filtered.length,
      lon: avg.lon / filtered.length,
      usedPoints: filtered.length,
      removedPoints: coordsArray.length - filtered.length,
    };
  },

  getCoordsStep(coordsArray) {
    navigator.geolocation.getCurrentPosition((position) => {
      const coords = {
        lat: position.coords.latitude,
        lon: position.coords.longitude,
      };
      coordsArray.push(coords);
    },
    (error) => console.error("Ошибка:", error),
        { 
            enableHighAccuracy: true, // Включает GPS (максимальная точность)
            maximumAge: 0,            // Запрещает использование кэша
            timeout: 10000            // Время ожидания ответа
        }

  );
  },
};